import React from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { setSocialShareDetail } from "../../../actions/shareSocial";
import { isVideo } from "../../../utils/utils";
import SkeletonLoading from "../SkeletonLoading/SkeletonLoading";
import "./NFTItem.css";
import { Button } from "react-bootstrap";
import GoForLoginModal from "../../Home/GoForLoginModal";
import { useS3Image } from "../../../hooks/useS3Image";
const LISTING_URL =
  process.env.REACT_APP_LISTING_SERVICE || "http://localhost:4001";

const NFTItem = ({ item, isHome = false, setSocial, isLoggedIn, handleViewClick }) => {
  let fileType = isVideo(item?.resource_type) ? "videos" : "images"
  const { resourceUrl, loading, error } = useS3Image(item?.resource_url, fileType);

 

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // Skeleton Card
  if (!item) {
    return (
      <div className="nft-card">
        <div className="nft-card-content">
          {/* Title and Token ID Skeleton */}
          <div className="main mb-3 align-items-center nucin" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div className="left">
              <SkeletonLoading width={130} height={16} />
            </div>
            <div className="right block-typ">
              <div className="category-icon ms-auto">
                <SkeletonLoading width={38} height={24} style={{ borderRadius: "6px" }} />
              </div>
            </div>
          </div>

          {/* Image Skeleton */}
          <div className="image mb-3">
            <SkeletonLoading style={{ width: "100%", height: "260px", borderRadius: "16px" }} />
          </div>

          {/* Owner Info Skeleton */}
          <div className="owner-section mb-3" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <SkeletonLoading width={16} height={16} style={{ borderRadius: "4px" }} />
            <SkeletonLoading width={60} height={14} />
            <SkeletonLoading width={90} height={14} />
          </div>

          {/* Bottom Info - Price and Created Time Skeleton */}
          <div className="main align-items-center mb-3" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <div className="left" style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <SkeletonLoading width={35} height={11} />
              <SkeletonLoading width={75} height={20} />
            </div>
            <div className="right text-end" style={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-end' }}>
              <SkeletonLoading width={70} height={11} />
              <SkeletonLoading width={90} height={14} />
            </div>
          </div>

          {/* Button Skeleton */}
          <div className="skeleton-button-wrapper">
            <SkeletonLoading style={{ width: "100%", height: "44px", borderRadius: "8px" }} />
          </div>
        </div>
      </div>
    );
  }

  // Actual Card with Data
  return (
    <div className={`nft-card ${isHome ? "tp show" : ""}`}>
      <div className="nft-card-content">
        {/* Title and Token ID */}
        <div className="main mb-3 align-items-center nucin">
          <div className="left">
            <h6 className={"HeadingEllipsis mb-0"}>
              {item?.title}
            </h6>
          </div>
          <div className="right block-typ">
            <div className="category-icon ms-auto">
              {item.blockchain_token_id && (
                <span id="numbers">#{item?.blockchain_token_id}</span>
              )}
            </div>
          </div>
        </div>

        {/* Image Section */}
        <Link to={`/detail/${item._id}`}>
          <div className="image mb-3">
            {isVideo(item?.resource_type) ? (
              <video key={resourceUrl} autoPlay loop muted playsInline>
                <source src={resourceUrl} type="video/mp4" />
              </video>
            ) : (

              <img
                src={resourceUrl}
                alt={item?.name || "NFT"}
                onError={(e) => {
                  e.target.src = "/images/placeholder.png";
                }}
              />

            )}

            {/* Status Badge */}
            {item?.on_sale && (
              <div className="status-badge sale-badge">
                <span>On Sale</span>
              </div>
            )}

            {/* Blockchain Badge */}
            {/* {item.royalties && (
              <div className="blockchain-badge">
                <span>Royality {item.royalties}%</span>
              </div>
            )} */}
          </div>
        </Link>
















        {/* Owner Info */}
        {(item.owner_details) && (
          <div className="owner-section mb-3">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="owner-icon"
            >
              <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2" />
              <path
                d="M4 20C4 16.6863 6.68629 14 10 14H14C17.3137 14 20 16.6863 20 20"
                stroke="currentColor"
                strokeWidth="2"
              />
            </svg>
            <span className="owner-label-text">Owned by</span>
            <Link to={`/profile/${item.owner_details?.user_name}`}>
              <span className="owner-text">
                {item.owner_details?.display_name || item.owner_details?.user_name}
              </span>
            </Link>
          </div>
        )}

        {/* Bottom Info - Price (Left) and Created Time (Right) */}
        <div className="main align-items-center mb-3">
          <div className="left">
            <span className="price-label">Price</span>
            <span className="price-value">
              {item.active_order?.price || item.price || '0'} NUC
            </span>
          </div>
          <div className="right text-end">
            <span className="info-label">Created</span>
            <span className="info-value">
              {formatDate(item.timestamps?.created_At || item.created_at)}
            </span>
          </div>
        </div>

        {/* View Detail Button */}
        <Button onClick={() => handleViewClick(item)} className="view-detail-btn">
          View Details
        </Button>
      </div>


    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.Auth.isLoggedIn,
});

export default connect(mapStateToProps, {
  setSocial: setSocialShareDetail,
})(NFTItem);
